import { useStepValidation } from 'features/libra/StepValidationContext'
import { useTicketAccess } from 'features/libra/ticket/TicketAccessContext'
import { useWorkflow } from 'features/libra/WorkflowContext'
import { useEffect, useMemo } from 'react'

import { readPlanningBasis } from './planningBasis'

export const usePlanningBasis = (
  config: Record<string, unknown>,
  readonly = false
) => {
  const { globalContext } = useWorkflow()
  const { fieldValues, ticketTags, ticketId, readOnly } = useTicketAccess()
  const { setValidationResult } = useStepValidation()
  const basis = useMemo(
    () => readPlanningBasis(config, fieldValues, globalContext),
    [config, fieldValues, globalContext]
  )
  useEffect(() => {
    // The mounted selector/form owns validation once the basis can be read.
    if (basis.status === 'invalid')
      setValidationResult({
        status: 'Error',
        message: 'The NII assessment basis needs attention',
      })
  }, [basis.status, setValidationResult])
  return {
    basis,
    ticketId,
    organizationId: ticketTags.organization ?? undefined,
    readonly: Boolean(readonly || readOnly),
  }
}
